import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";

import NavigationBar from "../../Pages/NavigationBar/NavigationBar";

import authChecker from "../../assets/Js/authChecker";
import { useRoleFinder } from "../../Hooks/useRoleFinder";
import { allowedPaths } from "../../assets/Js/roleBasedPaths";

export default function ProtectedRotue({
  Component,
  path,
  exact = true,
  showNavbar = true,
  otherProps,
}) {
  const setAreTracksLoading = otherProps?.setAreTracksLoading;
  const key = otherProps?.key;

  const isAuthenticated = authChecker();
  const findRole = useRoleFinder();

  let isUserAllowedRoutes = false;
  let redirectUrl = "/";
  let windowPath = window.location;

  if (isAuthenticated) {
    const currentUserRole = findRole();
    isUserAllowedRoutes = allowedPaths[currentUserRole]?.some(
      (eachVal) => eachVal === path
    );
  }

  let currentPath = "?redirecturl=" + (windowPath.pathname + windowPath.search);
  redirectUrl = `/login${currentPath}`;

  if (!isUserAllowedRoutes && isAuthenticated) {
    redirectUrl = "/unauthorized";
  }

  return (
    <>
      <Route
        exact={exact}
        path={path}
        render={(props) =>
          isAuthenticated && isUserAllowedRoutes ? (
            <>
              {showNavbar && (
                <NavigationBar setTrackLoader={setAreTracksLoading} />
              )}
              <Component {...props} {...otherProps} key={key} />
            </>
          ) : (
            <>
              <Redirect to={redirectUrl} />
            </>
          )
        }
      />
    </>
  );
}

ProtectedRotue.propTypes = {
  path: PropTypes.string,
  exact: PropTypes.bool,
  showNavbar: PropTypes.bool,
  otherProps: PropTypes.object,
};
